/**
 * Patch System for Jersey Zone Store
 * VERSION: UPDATED LAYOUT (Price Tightly Below Title)
 */

(function () {
  // Store selected patch products
  const selectedPatches = new Map();
  // Store cart item keys for patches (to remove them later)
  const patchCartKeys = new Map();
  // Flag to prevent infinite loops when syncing patch properties
  let isSyncingPatchProperties = false;
  // Flag to prevent infinite loops when deselecting patches programmatically
  let isDeselectingPatches = false;

  // Get product data from global variable (set by Liquid template)
  const productCollections = window.PATCH_SYSTEM_DATA?.productCollections || [];
  const productTitle = window.PATCH_SYSTEM_DATA?.productTitle || '';
  const productFormId = window.PATCH_SYSTEM_DATA?.productFormId || '';
  const productData = window.PATCH_SYSTEM_DATA?.product || {};

  // Flags for patch loading
  let patchesLoaded = false;
  let isLoadingPatches = false;
  let patchSectionExpanded = false;

  // --- INJECT CUSTOM CSS FOR PERFECT LAYOUT ---
  function injectPatchStyles() {
    const styleId = 'patch-system-styles-final-production';
    if (document.getElementById(styleId)) return;

    const css = `
      /* --- NUCLEAR CSS FIX --- */
      
      /* SECTION CONTAINER */
      .patch-position-patches {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-top: 10px;
        width: 100%;
      }

      /* CARD ITEM - SINGLE ROW ENFORCED */
      .patch-product-item {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: flex-start !important;
        
        width: 100% !important;
        background: #fff;
        border: 1px solid #e5e5e5 !important;
        border-radius: 4px !important;
        padding: 10px 12px !important;
        margin: 0 !important;
        
        cursor: pointer;
        box-sizing: border-box;
        transition: border-color 0.2s ease;
      }

      .patch-product-item:hover {
        border-color: #999 !important;
      }

      .patch-product-item.selected {
        border-color: #000 !important;
        background-color: #fff !important;
      }

      /* CHECKBOX */
      .patch-checkbox {
        width: 18px !important;
        height: 18px !important;
        cursor: pointer;
        margin: 0 15px 0 0 !important;
        accent-color: #000;
        flex-shrink: 0;
        display: block !important;
      }

      /* IMAGE */
      .patch-product-image {
        width: 45px !important;
        height: 45px !important;
        object-fit: contain !important;
        margin: 0 15px 0 0 !important;
        display: block !important;
        flex-shrink: 0;
      }

      /* INFO CONTAINER (Vertical Stack) - AQUI ESTÁ A CORREÇÃO PRINCIPAL */
      .patch-product-info {
        display: flex !important;
        flex-direction: column !important; /* Garante empilhamento vertical */
        justify-content: center !important; /* Centraliza no eixo vertical da imagem */
        align-items: flex-start !important; /* Alinha texto à esquerda */
        text-align: left !important;
        flex-grow: 1;
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      /* TITLE */
      .patch-product-title {
        display: block !important;
        font-size: 13px !important;
        font-weight: 700 !important; /* Negrito */
        color: #222 !important;
        margin: 0 0 2px 0 !important; /* Espaço mínimo abaixo do título (2px) */
        padding: 0 !important;
        line-height: 1.2 !important;
        text-transform: none !important;
      }

      /* PRICE */
      .patch-product-price {
        display: block !important;
        font-size: 13px !important;
        color: #666 !important; /* Cinza */
        margin: 0 !important; /* Remove margens para ficar grudado no título */
        padding: 0 !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
      }
      
      /* SECTION TITLES */
      .patch-position-title {
        font-size: 14px;
        font-weight: 600;
        margin-top: 15px;
        margin-bottom: 8px;
        color: #000;
        text-transform: capitalize;
      }
    `;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    document.head.appendChild(style);
  }

  // Inject styles immediately
  injectPatchStyles();

  // Helper function to format money according to shop settings
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '€{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return cents / 100;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }


  // Club to league mapping based on simplified names
  const clubToLeagueMap = {
    // Premier League
    'arsenal': 'premier-league',
    'aston villa': 'premier-league',
    'bournemouth': 'premier-league',
    'brentford': 'premier-league',
    'brighton': 'premier-league',
    'burnley': 'premier-league',
    'chelsea': 'premier-league',
    'crystal palace': 'premier-league',
    'everton': 'premier-league',
    'fulham': 'premier-league',
    'leeds': 'premier-league',
    'liverpool': 'premier-league',
    'manchester': 'premier-league',
    'newcastle': 'premier-league',
    'nottingham': 'premier-league',
    'sunderland': 'premier-league',
    'tottenham': 'premier-league',
    'west ham': 'premier-league',
    'wolves': 'premier-league',

    // La Liga
    'real madrid': 'laliga',
    'barcelona': 'laliga',
    'atletico': 'laliga',
    'sevilla': 'laliga',
    'betis': 'laliga',
    'valencia': 'laliga',
    'villarreal': 'laliga',
    'sociedad': 'laliga',
    'bilbao': 'laliga',
    'getafe': 'laliga',
    'osasuna': 'laliga',
    'espanyol': 'laliga',
    'celta': 'laliga',
    'granada': 'laliga',
    'mallorca': 'laliga',
    'rayo': 'laliga',
    'alaves': 'laliga',
    'leganes': 'laliga',
    'levante': 'laliga',

    // Bundesliga
    'bayern': 'bundesliga',
    'dortmund': 'bundesliga',
    'leipzig': 'bundesliga',
    'leverkusen': 'bundesliga',
    'stuttgart': 'bundesliga',
    'frankfurt': 'bundesliga',
    'wolfsburg': 'bundesliga',
    'gladbach': 'bundesliga',
    'hoffenheim': 'bundesliga',
    'freiburg': 'bundesliga',
    'mainz': 'bundesliga',
    'augsburg': 'bundesliga',
    'bochum': 'bundesliga',
    'köln': 'bundesliga',
    'union berlin': 'bundesliga',
    'werder': 'bundesliga',
    'heidenheim': 'bundesliga',
    'darmstadt': 'bundesliga',

    // Serie A
    'juventus': 'serie-a',
    'inter milan': 'serie-a',
    'milan': 'serie-a',
    'roma': 'serie-a',
    'lazio': 'serie-a',
    'napoli': 'serie-a',
    'atalanta': 'serie-a',
    'fiorentina': 'serie-a',
    'torino': 'serie-a',
    'bologna': 'serie-a',
    'verona': 'serie-a',
    'udinese': 'serie-a',
    'genoa': 'serie-a',
    'lecce': 'serie-a',
    'empoli': 'serie-a',
    'monza': 'serie-a',
    'cagliari': 'serie-a',
    'sassuolo': 'serie-a',

    // Ligue 1
    'paris': 'ligue-1',
    'marseille': 'ligue-1',
    'lyon': 'ligue-1',
    'monaco': 'ligue-1',
    'lille': 'ligue-1',
    'nice': 'ligue-1',
    'rennes': 'ligue-1',
    'nantes': 'ligue-1',
    'strasbourg': 'ligue-1',
    'montpellier': 'ligue-1',
    'toulouse': 'ligue-1',
    'reims': 'ligue-1',
    'metz': 'ligue-1',
    'brest': 'ligue-1',
    'lens': 'ligue-1',
    'lorient': 'ligue-1',
    'auxerre': 'ligue-1',
    'clermont': 'ligue-1',

    // Liga Portugal
    'benfica': 'liga-portugal',
    'porto': 'liga-portugal',
    'sporting': 'liga-portugal',
    'braga': 'liga-portugal',
    'guimaraes': 'liga-portugal',
    'boavista': 'liga-portugal',
    'estoril': 'liga-portugal',
    'famalicao': 'liga-portugal',
    'rio ave': 'liga-portugal',
    'arouca': 'liga-portugal',
    'casa pia': 'liga-portugal',
    'vizela': 'liga-portugal',
    'gil vicente': 'liga-portugal',
    'moreirense': 'liga-portugal',
    'portimonense': 'liga-portugal',

    // Brasileirão
    'flamengo': 'brasileirao',
    'fluminense': 'brasileirao',
    'botafogo': 'brasileirao',
    'vasco': 'brasileirao',
    'corinthians': 'brasileirao',
    'palmeiras': 'brasileirao',
    'são paulo': 'brasileirao',
    'sao paulo': 'brasileirao',
    'santos': 'brasileirao',
    'grêmio': 'brasileirao',
    'gremio': 'brasileirao',
    'internacional': 'brasileirao',
    'cruzeiro': 'brasileirao',
    'atlético mineiro': 'brasileirao',
    'atletico mineiro': 'brasileirao',
    'athletico': 'brasileirao',
    'bahia': 'brasileirao',
    'fortaleza': 'brasileirao',
    'ceará': 'brasileirao',
    'ceara': 'brasileirao',
    'goiás': 'brasileirao',
    'goias': 'brasileirao',
    'cuiabá': 'brasileirao',
    'cuiaba': 'brasileirao',
    'red bull bragantino': 'brasileirao',
    'bragantino': 'brasileirao',
    'coritiba': 'brasileirao',
    'vitória': 'brasileirao',
    'vitoria': 'brasileirao',
    'américa mineiro': 'brasileirao',
    'america mineiro': 'brasileirao',

    // Liga MX
    'américa': 'liga-mx',
    'america': 'liga-mx',
    'atlas': 'liga-mx',
    'atletico de san luis': 'liga-mx',
    'atletico san luis': 'liga-mx',
    'cruz azul': 'liga-mx',
    'guadalajara': 'liga-mx',
    'chivas': 'liga-mx',
    'chivas de guadalajara': 'liga-mx',
    'león': 'liga-mx',
    'leon': 'liga-mx',
    'monterrey': 'liga-mx',
    'rayados': 'liga-mx',
    'necaxa': 'liga-mx',
    'pachuca': 'liga-mx',
    'puebla': 'liga-mx',
    'pumas': 'liga-mx',
    'querétaro': 'liga-mx',
    'queretaro': 'liga-mx',
    'santos laguna': 'liga-mx',
    'tigres': 'liga-mx',
    'tijuana': 'liga-mx',
  };

  // Champions League specific club patches (order matters - more specific first)
  const championsLeagueClubPatches = {
    // CHELSEA CLUB WORLD CHAMPIONS PATCH START
    'chelsea': 'patch-club-world-champions-chelsea',
    // CHELSEA CLUB WORLD CHAMPIONS PATCH END
    'eintracht frankfurt': 'patch-champions-league',
    'atletico madrid': 'patch-champions-league',
    'borussia dortmund': 'patch-champions-league',
    'bayer leverkusen': 'patch-champions-league',
    'real madrid': 'patch-champions-league-15',
    'barcelona': 'patch-champions-league-5',
    'bayern': 'patch-champions-league-6',
    'liverpool': 'patch-champions-league-6',
    'milan': 'patch-champions-league-7',
    'paris': 'patch-uefa-champions-25-26',
    'tottenham': 'patch-champions-league',
    'atalanta': 'patch-champions-league',
    'monaco': 'patch-champions-league',
    'juventus': 'patch-champions-league',
    'sporting cp': 'patch-champions-league',
    'marseille': 'patch-champions-league',
    'villarreal': 'patch-champions-league',
    'manchester united': 'champions-league-patch-3x',
    'manchester city': 'patch-champions-league',
    'napoli': 'patch-champions-league',
    'benfica': 'patch-champions-league',
    'olympiacos': 'patch-champions-league',
    'arsenal': 'patch-champions-league'
  };

  // Libertadores patches
  const libertadoresPatches = {
    'flamengo': 'patch-libertadores-3',
    'palmeiras': 'patch-libertadores-3',
    'são paulo': 'patch-libertadores-3',
    'sao paulo': 'patch-libertadores-3',
    'internacional': 'patch-libertadores-2',
    'cruzeiro': 'patch-libertadores-2'
  };

  // Final Libertadores 2025
  const finalLibertadores2025Clubs = {
    'flamengo': 'patch-final-libertadores-2025',
    'palmeiras': 'patch-final-libertadores-2025'
  };

  // Participation Libertadores
  const participationLibertadoresClubs = ['internacional', 'corinthians', 'bahia', 'flamengo', 'botafogo', 'palmeiras', 'fortaleza', 'são paulo', 'sao paulo'];

  // Copa do Brasil
  const copaBrasilClubs = {
    'flamengo': 'patch-participation-copa-do-brasil',
    'palmeiras': 'patch-participation-copa-do-brasil',
    'são paulo': 'patch-participation-copa-do-brasil',
    'sao paulo': 'patch-participation-copa-do-brasil',
    'corinthians': 'patch-participation-copa-do-brasil',
    'santos': 'patch-participation-copa-do-brasil',
    'internacional': 'patch-participation-copa-do-brasil',
    'grêmio': 'patch-participation-copa-do-brasil',
    'gremio': 'patch-participation-copa-do-brasil',
    'atlético mineiro': 'patch-participation-copa-do-brasil',
    'atletico mineiro': 'patch-participation-copa-do-brasil',
    'athletico paranaense': 'patch-participation-copa-do-brasil',
    'athletico': 'patch-participation-copa-do-brasil',
    'fluminense': 'patch-participation-copa-do-brasil',
    'vasco da gama': 'patch-participation-copa-do-brasil',
    'vasco': 'patch-participation-copa-do-brasil',
    'cruzeiro': 'patch-participation-copa-do-brasil'
  };

  // Sudamericana
  const sudamericanaClubs = {
    'atlético mineiro': 'patch-participation-sudamericana',
    'atletico mineiro': 'patch-participation-sudamericana',
    'fluminense': 'patch-participation-sudamericana',
    'corinthians': 'patch-participation-sudamericana',
    'cruzeiro': 'patch-participation-sudamericana',
    'grêmio': 'patch-participation-sudamericana',
    'gremio': 'patch-participation-sudamericana',
    'vasco da gama': 'patch-participation-sudamericana',
    'vasco': 'patch-participation-sudamericana',
    'lanús': 'patch-participation-sudamericana',
    'lanus': 'patch-participation-sudamericana',
    'independiente': 'patch-participation-sudamericana',
    'godoy cruz': 'patch-participation-sudamericana',
    'huracán': 'patch-participation-sudamericana',
    'huracan': 'patch-participation-sudamericana',
    'independiente del valle': 'patch-participation-sudamericana',
    'bolívar': 'patch-participation-sudamericana',
    'bolivar': 'patch-participation-sudamericana',
    'once caldas': 'patch-participation-sudamericana',
    'alianza lima': 'patch-participation-sudamericana',
    'universidad de chile': 'patch-participation-sudamericana'
  };

  const titleKeywordPatches = [
    { keywords: ['world cup 2026', '2026 world cup', 'world cup'], handle: 'patch-world-cup-2026' }
  ];

  const customClubPatches = {
    'cruz azul': 'patch-liga-mx-campeon-c26-chest'
  };

  const worldCup2025ClubPatches = {
    'chelsea': 'patch-world-cup-2025-participation',
    'paris saint-germain': 'patch-world-cup-2025-participation',
    'psg': 'patch-world-cup-2025-participation',
    'real madrid': 'patch-world-cup-2025-participation',
    'bayern': 'patch-world-cup-2025-participation',
    'borussia dortmund': 'patch-world-cup-2025-participation',
    'manchester city': 'patch-world-cup-2025-participation',
    'juventus': 'patch-world-cup-2025-participation',
    'inter milan': 'patch-world-cup-2025-participation',
    'atlético de madrid': 'patch-world-cup-2025-participation',
    'atletico de madrid': 'patch-world-cup-2025-participation',
    'atlético madrid': 'patch-world-cup-2025-participation',
    'porto': 'patch-world-cup-2025-participation',
    'benfica': 'patch-world-cup-2025-participation',
    'red bull salzburg': 'patch-world-cup-2025-participation',
    'fluminense': 'patch-world-cup-2025-participation',
    'palmeiras': 'patch-world-cup-2025-participation',
    'flamengo': 'patch-world-cup-2025-participation',
    'botafogo': 'patch-world-cup-2025-participation',
    'river plate': 'patch-world-cup-2025-participation',
    'boca juniors': 'patch-world-cup-2025-participation',
    'inter miami': 'patch-world-cup-2025-participation',
    'pachuca': 'patch-world-cup-2025-participation',
    'monterrey': 'patch-world-cup-2025-participation',
    'seattle sounders': 'patch-world-cup-2025-participation',
    'los angeles fc': 'patch-world-cup-2025-participation',
    'la fc': 'patch-world-cup-2025-participation',
    'al hilal': 'patch-world-cup-2025-participation',
    'al ahly': 'patch-world-cup-2025-participation',
    'mamelodi sundowns': 'patch-world-cup-2025-participation',
    'urawa red diamonds': 'patch-world-cup-2025-participation',
    'auckland city': 'patch-world-cup-2025-participation'
  };

  // League to patch handle mapping
  const leaguePatchMap = {
    'premier-league': 'patch-premier-league',
    'laliga': 'patch-laliga',
    'bundesliga': 'patch-bundesliga',
    'serie-a': 'patch-serie-a',
    'ligue-1': 'patch-ligue-1',
    'liga-portugal': 'patch-liga-portugal',
    'brasileirao': 'patch-brasileirao',
    'liga-mx': 'patch-participation-liga-mx'
  };

  // Function to detect league and club from product title
  function detectLeagueAndClub(productTitle) {
    const titleLower = productTitle.toLowerCase();
    const detected = {
      league: null,
      club: null,
      championsLeaguePatch: null,
      libertadoresPatch: null,
      participationLibertadores: false,
      finalLibertadores2025: null,
      copaBrasil: null,
      sudamericana: null,
      titleKeywordPatch: null,
      specialClubPatch: null,
      worldCup2025ClubPatch: null
    };

    // Check for World Cup 2026 FIRST
    const has2026 = titleLower.includes('2026');
    const hasWorldCup = titleLower.includes('world cup') || titleLower.includes('worldcup');

    if (has2026 && hasWorldCup) {
      detected.titleKeywordPatch = 'patch-world-cup-2026';
    } else if (hasWorldCup &&
      !titleLower.includes('2025') &&
      !titleLower.includes('2026') &&
      !titleLower.includes('2024')) {
      detected.titleKeywordPatch = 'patch-world-cup-2026';
    }

    // Check for Champions League specific patches
    if (titleLower.includes('chelsea')) {
      detected.championsLeaguePatch = 'patch-club-world-champions-chelsea';
      detected.club = 'chelsea';
    } else {
      const sortedChampionsPatches = Object.entries(championsLeagueClubPatches).sort((a, b) => b[0].length - a[0].length);
      for (const [club, patchHandle] of sortedChampionsPatches) {
        if (club === 'chelsea') continue;

        if (titleLower.includes(club.toLowerCase())) {
          detected.championsLeaguePatch = patchHandle;
          detected.club = club;
          break;
        }
      }
    }

    // Check for Libertadores patches
    for (const [club, patchHandle] of Object.entries(libertadoresPatches)) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.libertadoresPatch = patchHandle;
        detected.club = club;
      }
    }

    // Check for Participation Libertadores
    if (participationLibertadoresClubs.some(club => titleLower.includes(club.toLowerCase()))) {
      detected.participationLibertadores = true;
    }

    // Check for Final Libertadores 2025
    for (const [club, patchHandle] of Object.entries(finalLibertadores2025Clubs)) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.finalLibertadores2025 = patchHandle;
        detected.club = club;
        break;
      }
    }

    // Check for Copa do Brasil
    const sortedCopaBrasilClubs = Object.entries(copaBrasilClubs).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedCopaBrasilClubs) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.copaBrasil = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check for Sudamericana
    const sortedSudamericanaClubs = Object.entries(sudamericanaClubs).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedSudamericanaClubs) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.sudamericana = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check for World Cup 2025 club patches
    const sortedWorldCup2025Clubs = Object.entries(worldCup2025ClubPatches).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedWorldCup2025Clubs) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.worldCup2025ClubPatch = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check for custom club-specific patches
    const sortedCustomClubPatches = Object.entries(customClubPatches).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedCustomClubPatches) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.specialClubPatch = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check club to league mapping
    const sortedClubs = Object.entries(clubToLeagueMap).sort((a, b) => b[0].length - a[0].length);
    for (const [club, league] of sortedClubs) {
      if (club === 'internacional') {
        if (titleLower.includes('internacional') && !titleLower.includes('inter milan')) {
          detected.league = league;
          if (!detected.club) {
            detected.club = club;
          }
          break;
        }
      } else if (titleLower.includes(club.toLowerCase())) {
        detected.league = league;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    return detected;
  }

  // Helper function to check if patch is a champion/trophies patch
  function isChampionOrTrophiesPatch(patch) {
    const handleLower = patch.handle.toLowerCase();
    const titleLower = patch.title.toLowerCase();

    if (handleLower.includes('patch-libertadores-2') ||
      handleLower.includes('patch-libertadores-3') ||
      handleLower.includes('patch-final-libertadores-')) {
      return true;
    }

    if (handleLower.includes('patch-champions-league') ||
      handleLower.includes('patch-world-champions') ||
      handleLower.includes('patch-uefa-champions')) {
      return true;
    }

    if (titleLower.includes('troféu') ||
      titleLower.includes('trophy') ||
      titleLower.includes('trophies') ||
      titleLower.includes('campeão') ||
      titleLower.includes('campeao') ||
      titleLower.includes('champion')) {
      return true;
    }

    return false;
  }

  // Helper function to check if patch is a participation patch
  function isParticipationPatch(patch) {
    if (isChampionOrTrophiesPatch(patch)) {
      return false;
    }
    return true;
  }

  // Function to validate and enforce sleeve patch selection rules
  function validateSleevePatchSelection(patch, patchKey, isNewPatch) {
    const isSleevePatch = patch.position === 'Sleeve';
    if (!isSleevePatch) return true;

    const isLibertadoresTrophiesPatch = isChampionOrTrophiesPatch(patch) &&
      (patch.handle.toLowerCase().includes('patch-libertadores-') ||
        patch.handle.toLowerCase().includes('patch-final-libertadores-'));

    const selectedSleevePatches = [];
    selectedPatches.forEach((selectedPatch, key) => {
      if (selectedPatch.position === 'Sleeve' && key !== patchKey) {
        selectedSleevePatches.push({ key, patch: selectedPatch });
      }
    });

    if (isLibertadoresTrophiesPatch) {
      removePatchesFromSelection(selectedSleevePatches);
      return true;
    }

    if (selectedSleevePatches.length > 0) {
      removePatchesFromSelection(selectedSleevePatches);
    }

    return true;
  }

  // Helper function to remove patches from selection
  function removePatchesFromSelection(patchesToRemove) {
    if (patchesToRemove.length === 0) return;

    isDeselectingPatches = true;
    patchesToRemove.forEach(({ key }) => {
      selectedPatches.delete(key);
      document.querySelectorAll('.patch-product-item').forEach(item => {
        const itemPatchKey = item.dataset.patchKey;
        if (itemPatchKey === key) {
          const cb = item.querySelector('.patch-checkbox');
          if (cb) {
            cb.checked = false;
            item.classList.remove('selected');
            cb.dispatchEvent(new Event('change'));
          }
        }
      });
    });
    isDeselectingPatches = false;
  }

  // Function to get patch position
  function getPatchPosition(product) {
    // Cruz Azul's commemorative badge is applied to the chest.
    if (product.handle === 'patch-liga-mx-campeon-c26-chest') return 'Chest';

    // Check for manual position override
    if (window.PATCH_POSITIONS && window.PATCH_POSITIONS[product.handle]) {
      return window.PATCH_POSITIONS[product.handle];
    }

    const titleLower = product.title.toLowerCase();

    if (titleLower.includes('world champions') || titleLower.includes('chelsea') && titleLower.includes('champions')) {
      return 'Chest';
    }

    if (product.handle && product.handle.toLowerCase().includes('patch-final-libertadores-2025')) {
      return 'Sleeve';
    }

    if (product.tags && product.tags.length > 0) {
      const positionTags = ['manga', 'torax', 'costas', 'peito', 'sleeve', 'chest', 'back'];
      for (const tag of product.tags) {
        const tagLower = tag.toLowerCase();
        if (positionTags.includes(tagLower)) {
          if (tagLower === 'manga') return 'Sleeve';
          if (tagLower === 'torax' || tagLower === 'peito') return 'Chest';
          if (tagLower === 'costas') return 'Back';
          return tag.charAt(0).toUpperCase() + tag.slice(1);
        }
      }
    }

    // Force English Translations
    if (titleLower.includes('manga') || titleLower.includes('sleeve') || titleLower.includes('manica')) return 'Sleeve';
    if (titleLower.includes('torax') || titleLower.includes('peito') || titleLower.includes('chest') || titleLower.includes('petto')) return 'Chest';
    if (titleLower.includes('costas') || titleLower.includes('back') || titleLower.includes('schiena')) return 'Back';

    return 'Sleeve';
  }

  // Function to load patch products
  async function loadPatchProducts() {
    const patchProductsSelector = document.getElementById('patch-products-selector');
    const patchProductsList = document.getElementById('patch-products-list');

    if (!patchProductsSelector || !patchProductsList) {
      return;
    }

    if (isLoadingPatches || patchesLoaded) {
      return;
    }

    isLoadingPatches = true;
    const patchProductsLoading = patchProductsSelector.querySelector('.patch-loading-container');
    if (patchProductsLoading) {
      patchProductsLoading.style.display = 'block';
    }
    patchProductsList.innerHTML = '';
    selectedPatches.clear();

    const patchSectionWrapper = document.querySelector('.patch-section-wrapper');
    const patchSectionHeader = document.querySelector('.patch-section-header');

    try {
      // Get product title - try multiple sources
      let currentProductTitle = productTitle;

      // Fallback 1: Try to get from PATCH_SYSTEM_DATA (may be updated)
      if (window.PATCH_SYSTEM_DATA && window.PATCH_SYSTEM_DATA.productTitle) {
        currentProductTitle = window.PATCH_SYSTEM_DATA.productTitle;
      }

      // Fallback 2: Try to get from DOM (h1 with product title)
      if (!currentProductTitle || currentProductTitle.trim() === '') {
        const productTitleElement = document.querySelector('h1.product-form__title, h1.product__title, h1[data-product-title]');
        if (productTitleElement) {
          currentProductTitle = productTitleElement.textContent.trim();
        }
      }

      // Fallback 3: Try to get from meta tag
      if (!currentProductTitle || currentProductTitle.trim() === '') {
        const metaTitle = document.querySelector('meta[property="og:title"]');
        if (metaTitle && metaTitle.content) {
          currentProductTitle = metaTitle.content.trim();
        }
      }

      if (currentProductTitle && currentProductTitle.toLowerCase().includes('patch')) {
        if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
        if (patchSectionHeader) patchSectionHeader.style.display = 'none';
        patchProductsList.innerHTML = '';
        if (patchProductsLoading) patchProductsLoading.style.display = 'none';
        patchesLoaded = true;
        isLoadingPatches = false;
        return;
      }

      if (!currentProductTitle || currentProductTitle.trim() === '') {
        console.warn('Patch System: Could not find product title');
        if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
        if (patchSectionHeader) patchSectionHeader.style.display = 'none';
        patchProductsList.innerHTML = '';
        if (patchProductsLoading) patchProductsLoading.style.display = 'none';
        patchesLoaded = true;
        isLoadingPatches = false;
        return;
      }

      const detected = detectLeagueAndClub(currentProductTitle);
      let patchHandles = [];

      // Debug: Log detection results for troubleshooting
      if (currentProductTitle && currentProductTitle.toLowerCase().includes('corinthians')) {
        console.log('Corinthians product detected:', currentProductTitle);
        console.log('Detection results:', detected);
      }

      if (detected.championsLeaguePatch) {
        patchHandles.push(detected.championsLeaguePatch);
      }

      if (detected.libertadoresPatch) {
        patchHandles.push(detected.libertadoresPatch);
      }

      if (detected.participationLibertadores && !detected.libertadoresPatch) {
        patchHandles.push('patch-participation-libertadores');
      }

      if (detected.finalLibertadores2025) {
        patchHandles.push(detected.finalLibertadores2025);
      }

      if (detected.copaBrasil) {
        patchHandles.push(detected.copaBrasil);
      }

      if (detected.sudamericana) {
        patchHandles.push(detected.sudamericana);
      }

      if (detected.worldCup2025ClubPatch) {
        patchHandles.push(detected.worldCup2025ClubPatch);
      }

      if (detected.titleKeywordPatch) {
        patchHandles.push(detected.titleKeywordPatch);
      }

      if (!detected.titleKeywordPatch && currentProductTitle) {
        const titleLowerCheck = currentProductTitle.toLowerCase();
        if (titleLowerCheck.includes('2026') &&
          (titleLowerCheck.includes('world cup') || titleLowerCheck.includes('worldcup'))) {
          patchHandles.push('patch-world-cup-2026');
        }
      }

      if (detected.specialClubPatch) {
        patchHandles.push(detected.specialClubPatch);
      }

      // Add league patch (Brasileirão for Corinthians)
      if (detected.league && leaguePatchMap[detected.league]) {
        if (detected.league === 'liga-mx' && detected.specialClubPatch) {
          // Skip
        } else {
          patchHandles.push(leaguePatchMap[detected.league]);
        }
      }

      // Check for Manual Rules from Theme Editor








      // FUT LATINO SPAIN FINAL PATCH SET START
      // One paid item containing both 2026 final patches for Spain shirts.
      const spainPatchIdentity = `${currentProductTitle || ''} ${productData?.handle || ''}`.toLowerCase();
      if (['españa', 'espana', 'spain'].some(keyword => spainPatchIdentity.includes(keyword))) {
        patchHandles.push('world-cup-2026-final-patch-set');
        if (!window.PATCH_POSITIONS) window.PATCH_POSITIONS = {};
        window.PATCH_POSITIONS['world-cup-2026-final-patch-set'] = 'Sleeve';
      }
      // FUT LATINO SPAIN FINAL PATCH SET END

      // SPAIN WORLD CHAMPIONS CHEST PATCH START
      // Spain's gold World Champions badge belongs on the chest, independently of sleeve patches.
      const spainWorldChampionsIdentity = `${currentProductTitle || ''} ${productData?.handle || ''}`.toLowerCase();
      if (['españa', 'espana', 'spain'].some(keyword => spainWorldChampionsIdentity.includes(keyword))) {
        patchHandles.push('patch-world-champions');
        if (!window.PATCH_POSITIONS) window.PATCH_POSITIONS = {};
        window.PATCH_POSITIONS['patch-world-champions'] = 'Chest';
      }
      // SPAIN WORLD CHAMPIONS CHEST PATCH END

      if (window.MANUAL_PATCH_RULES && Array.isArray(window.MANUAL_PATCH_RULES)) {
        const titleLower = currentProductTitle.toLowerCase();
        window.MANUAL_PATCH_RULES.forEach(rule => {
          if (rule.keywords && rule.patchHandle) {
            const keywords = rule.keywords;
            const match = keywords.some(keyword => titleLower.includes(keyword.trim().toLowerCase()));

            if (match) {
              patchHandles.push(rule.patchHandle);
              // Store position preference for this patch
              if (rule.position) {
                if (!window.PATCH_POSITIONS) window.PATCH_POSITIONS = {};
                window.PATCH_POSITIONS[rule.patchHandle] = rule.position;
              }
            }
          }
        });
      }

      // FUT LATINO ARSENAL PATCH OVERRIDE START
      // Arsenal only: the gold champions patch and the Champions League patch share one sleeve group.
      const arsenalPatchIdentity = `${currentProductTitle || ''} ${productData?.handle || ''}`.toLowerCase();
      if (arsenalPatchIdentity.includes('arsenal')) {
        patchHandles = ['patch-premier-league-winner', 'patch-champions-league'];
        if (!window.PATCH_POSITIONS) window.PATCH_POSITIONS = {};
        window.PATCH_POSITIONS['patch-premier-league-winner'] = 'Sleeve';
        window.PATCH_POSITIONS['patch-champions-league'] = 'Sleeve';
      }
      // FUT LATINO ARSENAL PATCH OVERRIDE END

      // FUT LATINO PORTUGAL CLUB PATCH OVERRIDES START
      // Keep each Portuguese club's current competitions isolated from imported source tags.
      const portugalClubIdentity = `${currentProductTitle || ''} ${productData?.handle || ''}`.toLowerCase();
      if (portugalClubIdentity.includes('fc porto') || portugalClubIdentity.includes('porto')) {
        patchHandles = ['patch-liga-portugal', 'patch-liga-portugal-champions-porto'];
        if (!window.PATCH_POSITIONS) window.PATCH_POSITIONS = {};
        window.PATCH_POSITIONS['patch-liga-portugal'] = 'Sleeve';
        window.PATCH_POSITIONS['patch-liga-portugal-champions-porto'] = 'Sleeve';
      } else if (portugalClubIdentity.includes('sporting cp') || portugalClubIdentity.includes('sporting')) {
        patchHandles = ['patch-liga-portugal', 'patch-champions-league'];
        if (!window.PATCH_POSITIONS) window.PATCH_POSITIONS = {};
        window.PATCH_POSITIONS['patch-liga-portugal'] = 'Sleeve';
        window.PATCH_POSITIONS['patch-champions-league'] = 'Sleeve';
      }
      // FUT LATINO PORTUGAL CLUB PATCH OVERRIDES END

      if (patchHandles.length === 0) {
        const relevantCollections = productCollections.filter(c => {
          return ['laliga', 'brasileirao', 'premier-league', 'bundesliga', 'serie-a', 'ligue-1', 'champions-league', 'liga-portugal', 'liga-mx'].includes(c);
        });

        relevantCollections.forEach(collection => {
          if (leaguePatchMap[collection]) {
            patchHandles.push(leaguePatchMap[collection]);
          }
        });
      }

      // FUT LATINO INTER MIAMI ATV OVERRIDE
      const miamiIdentity = String(currentProductTitle || '') + ' ' + String(productData?.handle || '') + ' ' + JSON.stringify(productData?.tags || []);
      if (/inter[ -]miami|lm10-inter-miami/i.test(miamiIdentity)) {
        patchHandles = ['atv-patch'];
        if (!window.PATCH_POSITIONS) window.PATCH_POSITIONS = {};
        window.PATCH_POSITIONS['atv-patch'] = 'Sleeve';
      }

      patchHandles = [...new Set(patchHandles)];

      if (patchHandles.length === 0) {
        if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
        if (patchSectionHeader) patchSectionHeader.style.display = 'none';
        patchProductsList.innerHTML = '';
        if (patchProductsLoading) patchProductsLoading.style.display = 'none';
        patchesLoaded = true;
        isLoadingPatches = false;
        return;
      }

      const patchProducts = [];

      for (const handle of patchHandles) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            const product = await response.json();
            patchProducts.push(product);
          }
        } catch (error) {
          // Silently fail
        }
      }

      if (patchProducts.length === 0) {
        if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
        if (patchSectionHeader) patchSectionHeader.style.display = 'none';
        patchProductsList.innerHTML = '';
      } else {
        const patchesByPosition = new Map();

        patchProducts.forEach((product, index) => {
          const variant = product.variants[0];
          const patchPosition = getPatchPosition(product);

          if (!patchesByPosition.has(patchPosition)) {
            patchesByPosition.set(patchPosition, []);
          }

          patchesByPosition.get(patchPosition).push({
            product: product,
            variant: variant,
            index: index
          });
        });

        patchesByPosition.forEach((patches, position) => {
          const sortedPatches = [...patches].sort((a, b) => {
            const patchA = { handle: a.product.handle, title: a.product.title };
            const patchB = { handle: b.product.handle, title: b.product.title };

            const isAParticipation = isParticipationPatch(patchA);
            const isBParticipation = isParticipationPatch(patchB);

            if (isAParticipation && !isBParticipation) return -1;
            if (!isAParticipation && isBParticipation) return 1;

            return 0;
          });

          const positionSection = document.createElement('div');
          positionSection.className = 'patch-position-section';

          const positionTitle = document.createElement('div');
          positionTitle.className = 'patch-position-title';
          positionTitle.textContent = position.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
          positionSection.appendChild(positionTitle);

          const patchesContainer = document.createElement('div');
          patchesContainer.className = 'patch-position-patches';

          sortedPatches.forEach(({ product, variant, index }) => {
            const priceValue = variant.price ? (variant.price / 100) : 5.00;
            const price = priceValue.toFixed(2);

            let imageUrl = '';
            if (product.images && product.images.length > 0) {
              imageUrl = product.images[0];
            } else if (product.featured_image) {
              imageUrl = product.featured_image;
            } else {
              imageUrl = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
            }

            const uniqueId = `patch-${product.id}-${variant.id}-${index}`;

            const patchItem = document.createElement('div');
            patchItem.className = 'patch-product-item';
            patchItem.dataset.productId = product.id;
            patchItem.dataset.variantId = variant.id;
            patchItem.dataset.productHandle = product.handle;
            patchItem.dataset.price = price;
            patchItem.dataset.patchKey = `${variant.id}-${index}`;

            const patchTitle = product.title.trim();
            const formattedPrice = formatMoney(variant.price || 500); 

            // --- HTML STRUCTURE FIXED (USING DIVs FOR VERTICAL STACKING) ---
            patchItem.innerHTML = `
              <input type="checkbox" id="${uniqueId}" class="patch-checkbox">
              <img src="${imageUrl}" alt="${patchTitle}" class="patch-product-image" loading="lazy">
              <div class="patch-product-info">
                <div class="patch-product-title">${patchTitle}</div>
                <div class="patch-product-price">+ ${formattedPrice}</div>
              </div>
            `;

            // Click handling for the whole row
            patchItem.addEventListener('click', function (e) {
                // If clicked directly on checkbox, let standard behavior happen
                if (e.target.type === 'checkbox') {
                  return;
                }
                e.preventDefault();
                const cb = patchItem.querySelector('.patch-checkbox');
                if (cb) {
                  cb.checked = !cb.checked;
                  cb.dispatchEvent(new Event('change'));
                }
            });

            const checkbox = patchItem.querySelector('.patch-checkbox');

            checkbox.addEventListener('change', async function () {
              if (isDeselectingPatches) {
                return;
              }

              const patchKey = `${variant.id}-${index}`;

              if (this.checked) {
                const patch = {
                  id: variant.id,
                  productId: product.id,
                  handle: product.handle,
                  title: product.title,
                  price: parseFloat(price),
                  position: position
                };

                const isValid = validateSleevePatchSelection(patch, patchKey, true);

                if (!isValid) {
                  this.checked = false;
                  patchItem.classList.remove('selected');
                  return;
                }

                selectedPatches.set(patchKey, patch);
                patchItem.classList.add('selected');

                // Don't add to cart immediately - only store selection
                // Patches will be added when product is added

              } else {
                const patch = selectedPatches.get(patchKey);
                selectedPatches.delete(patchKey);
                patchItem.classList.remove('selected');
              }
            });

            patchesContainer.appendChild(patchItem);
          });

          positionSection.appendChild(patchesContainer);
          patchProductsList.appendChild(positionSection);
        });
      }

    } catch (error) {
      console.error('Error loading patches:', error);
      patchProductsList.innerHTML = '<p>Error loading patches. Please try again.</p>';
      if (patchProductsLoading) {
        patchProductsLoading.style.display = 'none';
      }
      patchesLoaded = true;
      isLoadingPatches = false;
    } finally {
      if (patchProductsLoading) {
        patchProductsLoading.style.display = 'none';
      }
      isLoadingPatches = false;
      patchesLoaded = true;
      window.patchesLoaded = true;
      window.isLoadingPatches = false;
    }
  }

  function clearSelectedPatchItems() {
    selectedPatches.clear();
    patchCartKeys.clear();
    document.querySelectorAll('.patch-product-item').forEach(item => item.classList.remove('selected'));
    document.querySelectorAll('.patch-checkbox').forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  function extractPropertiesFromForm(formData) {
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propertyName = key.slice(11, -1);
        if (value && value.trim() !== '') {
          properties[propertyName] = value;
        }
      }
    }
    return properties;
  }

  function getCurrentVariantId() {
    const productForm = document.getElementById(productFormId);
    if (!productForm) return null;
    const variantInput = productForm.querySelector('input[name="id"]');
    return variantInput ? parseInt(variantInput.value, 10) : null;
  }

  // CRITICAL FIX: Add patches FIRST, then main product
  async function submitFormWithPatches(productForm) {
    const addButton = productForm.querySelector('[data-product-add-to-cart-button]');
    const secondaryButton = productForm.querySelector('[data-shopify="payment-button"] button');

    const setLoadingState = (isLoading) => {
      if (addButton) {
        if (isLoading) {
          addButton.setAttribute('aria-busy', 'true');
          addButton.classList.add('is-loading');
          addButton.disabled = true;
        } else {
          addButton.removeAttribute('aria-busy');
          addButton.classList.remove('is-loading');
          addButton.disabled = false;
        }
      }
      if (secondaryButton) {
        secondaryButton.disabled = isLoading;
      }
    };

    try {
      setLoadingState(true);

      const uniqueItemId = Date.now().toString() + '-' + Math.random().toString(36).substr(2, 9);

      const formData = new FormData(productForm);
      const quantity = parseInt(formData.get('quantity') || '1', 10);
      const variantId = formData.get('id');

      if (!variantId) {
        throw new Error('Please select a variant before adding to cart.');
      }

      const mainItem = {
        id: parseInt(variantId, 10),
        quantity: quantity
      };

      const sellingPlanId = formData.get('selling_plan');
      if (sellingPlanId) {
        mainItem.selling_plan = sellingPlanId;
      }

      const mainProperties = extractPropertiesFromForm(formData);
      if (Object.keys(mainProperties).length) {
        mainItem.properties = mainProperties;
      }

      // STEP 1: Add patches FIRST (one by one to ensure order)
      const patchTitles = [];
      if (selectedPatches.size > 0) {
        const validatedPatches = [];

        selectedPatches.forEach((patch, patchKey) => {
          const isValid = validateSleevePatchSelection(patch, patchKey, false);
          if (isValid) {
            validatedPatches.push({ patch, patchKey });
            patchTitles.push(patch.title);
          } else {
            selectedPatches.delete(patchKey);
            document.querySelectorAll('.patch-product-item').forEach(item => {
              const itemPatchKey = item.dataset.patchKey;
              if (itemPatchKey === patchKey) {
                const cb = item.querySelector('.patch-checkbox');
                if (cb) {
                  cb.checked = false;
                  item.classList.remove('selected');
                }
              }
            });
          }
        });

        for (const { patch } of validatedPatches) {
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [{
                  id: parseInt(patch.id, 10),
                  quantity: quantity
                }]
              })
            });
          } catch (patchError) {
            console.warn('Error adding patch:', patchError);
          }
        }
      }

      // STEP 2: Add main product AFTER patches
      if (patchTitles.length > 0) {
        mainItem.properties = mainItem.properties || {};
        mainItem.properties['Selected patches'] = patchTitles.join(', ');
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: [mainItem] })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.description || responseData.message || 'Error adding product to cart');
      }

      // Refresh cart
      const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';
      const cartResponse = await fetch(`${cartUrl}.js`);
      const cartData = await cartResponse.json();

      try {
        const sectionsResponse = await fetch(`${cartUrl}?sections=mini-cart`);
        if (sectionsResponse.ok) {
          const sectionsData = await sectionsResponse.json();
          cartData.sections = sectionsData.sections;
        }
      } catch (err) {
        console.warn('Could not load sections:', err);
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartData }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cartData,
          openMiniCart: window.themeVariables?.settings?.cartType === 'drawer'
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('variant:added', {
        bubbles: true,
        detail: {
          product: productData,
          variantId: parseInt(variantId, 10),
          quantity: quantity
        }
      }));

      // Clear patch selections
      patchCartKeys.clear();
      selectedPatches.clear();

      document.querySelectorAll('.patch-product-item').forEach(item => item.classList.remove('selected'));
      document.querySelectorAll('.patch-checkbox').forEach(checkbox => {
        checkbox.checked = false;
      });

    } catch (error) {
      console.error('Error adding product:', error);
      alert(error.message || 'Error adding product to cart. Please try again.');
    } finally {
      setLoadingState(false);
    }
  }

  // Make functions available globally
  window.PATCH_SYSTEM = {
    loadPatchProducts,
    submitFormWithPatches,
    clearSelectedPatchItems,
    getCurrentVariantId,
    selectedPatches,
    patchesLoaded,
    isLoadingPatches
  };

  // Initialize patch toggle
  function initPatchToggle() {
    const patchSectionToggle = document.querySelector('.patch-section-toggle');
    if (!patchSectionToggle) {
      return;
    }

    const patchProductsSelector = document.getElementById('patch-products-selector');
    if (!patchProductsSelector) {
      return;
    }

    if (patchSectionToggle.dataset.listenerAttached === 'true') {
      return;
    }

    patchSectionToggle.dataset.listenerAttached = 'true';

    patchSectionToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      patchSectionExpanded = !patchSectionExpanded;
      const selector = document.getElementById('patch-products-selector');
      const arrowDown = document.querySelector('.patch-arrow-down');
      const arrowUp = document.querySelector('.patch-arrow-up');
      const wrapper = document.querySelector('.patch-section-wrapper');

      if (patchSectionExpanded) {
        if (selector) selector.style.display = 'block';
        if (arrowDown) arrowDown.style.display = 'none';
        if (arrowUp) arrowUp.style.display = 'block';
        if (wrapper) wrapper.classList.add('expanded');
        if (window.PATCH_SYSTEM.loadPatchProducts && !window.PATCH_SYSTEM.patchesLoaded && !window.PATCH_SYSTEM.isLoadingPatches) {
          setTimeout(function () {
            window.PATCH_SYSTEM.loadPatchProducts();
          }, 100);
        }
      } else {
        if (selector) selector.style.display = 'none';
        if (arrowDown) arrowDown.style.display = 'block';
        if (arrowUp) arrowUp.style.display = 'none';
        if (wrapper) wrapper.classList.remove('expanded');
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initPatchToggle, 100);
      setTimeout(initPatchToggle, 500);
      setTimeout(initPatchToggle, 1000);
    });
  } else {
    setTimeout(initPatchToggle, 100);
    setTimeout(initPatchToggle, 500);
    setTimeout(initPatchToggle, 1000);
  }

  window.addEventListener('load', function () {
    setTimeout(initPatchToggle, 100);
  });

  // Handle form submission
  const productFormElement = document.getElementById(productFormId);
  if (productFormElement) {
    // Handle form submission
    productFormElement.addEventListener('submit', function (e) {
      if (selectedPatches.size > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        submitFormWithPatches(productFormElement);
      }
    }, true);
  }

})();
